module.exports = __webpack_public_path__ + "img/woman.b6c8cdd0.png";